import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { Location } from 'legacy/components/LoadOffer/Location'
import { Label } from 'legacy/components/LoadOffer/Section'
import { screen } from 'legacy/styles/screen'

export const StyledLink = styled(Link)`
  color: rgb(${getToken('color-text-primary')});
`

export const IconContainer = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${getToken('border-radius-l')};
  margin-right: ${getToken('spacing-4')};
  background-color: rgb(${getToken('color-neutral-20')});
`

export const FacilityLabel = styled(Label)`
  color: rgb(${getToken('color-neutral-darker')});
  min-width: 125px;
`

export const StyledLocation = styled(Location)`
  padding: 8px 0;
`

export const Details = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  width: 100%;
`

export const Warehouse = styled.div`
  display: flex;
  flex-basis: 100%;
  flex-flow: row nowrap;
  align-self: stretch;

  border: 1px solid rgb(${getToken('color-neutral-20')});

  ${screen.md} {
    flex-basis: 65%;
  }
`

export const AppointmentDesktop = styled.div`
  display: none;
  flex-basis: 35%;
  align-self: center;
  padding-left: 16px;

  ${screen.md} {
    display: flex;
  }
`

export const AppointmentMobile = styled.div`
  display: flex;
  flex-basis: 35%;
  align-items: center;
  padding: 0 2px 8px 0;

  font-size: 14px;

  ${screen.md} {
    display: none;
  }
`

export const WarehouseLocation = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  padding: ${getToken('spacing-2')} 0 0 ${getToken('spacing-2')};
`

export const FacilityInfo = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  padding: 0 0 ${getToken('spacing-2')} ${getToken('spacing-2')};

  transition: opacity 80ms linear;

  @media (min-width: 376px) {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    min-width: 231px;

    section {
      margin-top: -6px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;

      width: 1px;
      height: 100%;

      content: '';
    }
  }
`
